module.exports = __webpack_public_path__ + "static/media/dem_dri_saw.2260783c.png";